import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink as ReactRouterLink } from "react-router-dom";

import { EmailIcon, ExternalLinkIcon, InfoIcon, PhoneIcon, TimeIcon } from "@chakra-ui/icons";
import {
	Box,
	Button,
	Divider,
	HStack,
	Link,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverCloseButton,
	PopoverContent,
	PopoverHeader,
	PopoverTrigger,
	Stack,
	Text,
} from "@chakra-ui/react";
import { CgProfile } from "react-icons/cg";

export default function TenantPopover({ contact, propertyId, former, handleFormer }) {
	const { t } = useTranslation();
	return (
		<Popover>
			<PopoverTrigger>
				<Button
					width={"fit-content"}
					maxW="200px"
					size={"sm"}
					variant="outline"
					_hover={{ bg: former ? "gray.100" : "green.50" }}
					fontWeight="medium"
					textTransform={"capitalize"}
					leftIcon={<InfoIcon color={former ? "gray.500" : "green.500"} />}
				>
					<Text isTruncated>{contact.name}</Text>
				</Button>
			</PopoverTrigger>
			<PopoverContent>
				<PopoverArrow />
				<PopoverCloseButton />
				<PopoverHeader fontWeight="semibold" borderBottomWidth="1px" p={4} bg={former ? "gray.50" : "green.50"} borderTopRadius="md">
					{t("property.contactInformation")} -{" "}
					<Text as="span" color={former ? "gray.600" : "green.600"}>
						{t("table.tenant")}
					</Text>
				</PopoverHeader>
				<PopoverBody py={4}>
					<Stack spacing={4} style={{ whiteSpace: "normal" }}>
						<Box>
							<HStack spacing={2} align="center">
								<CgProfile color="gray.600" />
								<Text flex="1" fontWeight="medium">
									{contact.name}
								</Text>
							</HStack>
						</Box>
						<HStack spacing={2} align="center">
							<EmailIcon color="blue.500" />
							<Text flex="1" fontWeight="medium">
								{contact.email}
							</Text>
						</HStack>
						<HStack spacing={2} align="center">
							<PhoneIcon color="green.500" />
							<Text flex="1" fontWeight="medium">
								{contact.phoneNumber}
							</Text>
						</HStack>
						{contact.phoneNumber2 && (
							<HStack spacing={2} align="center">
								<PhoneIcon color="green.500" />
								<Text flex="1" fontWeight="medium">
									{contact.phoneNumber2}
								</Text>
							</HStack>
						)}
						<Divider />
						<Stack direction="row" spacing={2}>
							{handleFormer && (
								<Button
									size="sm"
									variant="ghost"
									leftIcon={<TimeIcon />}
									onClick={() => handleFormer(contact, propertyId, former)}
									_hover={{ bg: former ? "green.50" : "gray.100" }}
									color={former ? "green.500" : "gray.500"}
								>
									{t(`property.${former ? "markActive" : "markFormer"}`)}
								</Button>
							)}
							<Link as={ReactRouterLink} to={`/tenant/view/${propertyId}/${contact.id}`} _hover={{ textDecoration: "none" }} flex="1">
								<Button
									width="full"
									colorScheme={former ? "gray" : "green"}
									variant="ghost"
									size="sm"
									leftIcon={<ExternalLinkIcon />}
									_hover={{ bg: former ? "gray.100" : "green.50" }}
								>
									{t("table.view")}
								</Button>
							</Link>
						</Stack>
					</Stack>
				</PopoverBody>
			</PopoverContent>
		</Popover>
	);
}
